import React from 'react'
import { useSelector } from 'react-redux'
import { selectAppConfig } from 'store/app/app.selectors'
import AfterCallWorkView from './afterCallWork'
import './afterCallWork.scss'

type Props = {}

const AfterCallWork: React.FC<Props> = () => {
    const appConfig = useSelector(selectAppConfig)

    return <AfterCallWorkView appConfig={appConfig} />
}

export default AfterCallWork
